import { useEffect } from "react";
import Navigation from "@/components/Navigation";
import SubHero from "@/components/SubHero";
import CapitalFundingAbout from "@/components/CapitalFundingAbout";
import CapitalFunding from "@/components/CapitalFunding";
import LendingPartners from "@/components/LendingPartners";
import ContactSection from "@/components/ContactSection";
import Footer from "@/components/Footer";

export default function CapitalFundingPage() {
  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
    document.title =
      "Capital Funding — Catalyst Global Partners";
  }, []);

  return (
    <main data-testid="capital-funding-page" className="bg-[#FAFAF7] text-[#0B1A36]">
      <Navigation />
      <SubHero
        overline="Division 01"
        title={
          <>
            Capital &amp; Debt Funding,
            <br />
            <span className="italic text-white/65">structured for ambition.</span>
          </>
        }
        description="Your trusted partner for tailored financial solutions and sustainable business growth. We bridge ambition and capital with India's deepest network of banks, NBFCs and institutional investors — and structure deals that actually close."
        image="https://images.unsplash.com/photo-1486406146926-c627a92ad1ab?crop=entropy&cs=srgb&fm=jpg&q=85&w=2400"
        primaryCta={{ label: "Talk to Our Advisory Team", href: "#contact" }}
        secondaryCta={{ label: "See What We Fund", href: "#capital-funding" }}
      />
      <CapitalFundingAbout />
      <CapitalFunding />
      <LendingPartners />
      <ContactSection />
      <Footer />
    </main>
  );
}
